import {colors} from "styles";

export const PAYMENT_STATUS_ENUM_LABELS: Record<number, string> = {
  0: "Sin reportar",
  1: "Aprobado",
  2: "Reportado",
};

export const PAYMENT_STATUS_ENUM_COLORS: Record<number, string> = {
  0: colors["heart"],
  1: colors["success"],
  2: colors["secondary"],
};

export const PAYMENT_LIST_OPTION: {label: string; value: string}[] = [
  {label: "Sin reportar", value: "0"},
  {label: "Aprobado", value: "1"},
  {label: "Reportado", value: "2"},
];
